import { ScriptingLanguage } from "@octopusdeploy/octopus-server-client";
import type { ArgoCDInstanceConfiguration } from "~/areas/infrastructure/components/ArgoCDInstances/ArgoCDInstanceConfiguration";
import type { Language, TextFormat } from "~/components/CodeEditor/CodeEditor";
import { generateNamespace, generateReleaseName, getValidName } from "~/utils/HelmCommands/HelmCommandHelperMethods";
import { HelmUpgradeCommandBuilder } from "~/utils/HelmCommands/HelmUpgradeCommandBuilder";
const registryUrl: string = "oci://registry-1.docker.io/octopusdeploy/octopus-argocd-gateway-chart";
export function generateHelmCommand(configuration: ArgoCDInstanceConfiguration, accessToken: string | undefined, language: ScriptingLanguage | Language | TextFormat): string {
    const lineBreak = language === ScriptingLanguage.Bash ? "\\" : "`";
    const releaseName = generateReleaseName(configuration.name);
    const namespace = generateArgoCDGatewayNamespace(configuration.name);
    const name = getValidName(configuration.name);
    return new HelmUpgradeCommandBuilder("*.*", namespace, releaseName, registryUrl, lineBreak)
        .withValue("registration.octopus.name", name)
        .withValue("registration.octopus.serverApiUrl", configuration.octopusServerUrl)
        .withValue("registration.octopus.serverAccessToken", accessToken)
        .withValue("registration.octopus.environments", configuration.environmentSlugs)
        .withValue("registration.octopus.spaceId", configuration.spaceId)
        .withValue("gateway.octopus.serverGrpcUrl", configuration.octopusGrpcUrl)
        .withValue("gateway.argocd.serverGrpcUrl", `grpc://${configuration.argoCDUrl}`)
        .withValue("gateway.argocd.insecure", `false`)
        .withValue("gateway.argocd.plaintext", `false`)
        .withValue("gateway.argocd.authenticationToken", configuration.argoCDAuthenticationToken)
        .toCommandString();
}
export function generateArgoCDGatewayNamespace(name: string) {
    return generateNamespace(name, "octo-argo-gateway");
}
